import { FC } from 'react';
import styled from './index.module.scss';

interface IProps {
    type?: string;
}

const HowUse: FC<IProps> = ({}) => {
    const list = [
        {
            step: 'ステップ1：',
            title: 'マイページで獲得ポイント確認',
            subtitle: 'マイページで獲得したポイント数を確認しましょう。',
        },
        {
            step: 'ステップ2：',
            title: '貯めたポイントをショッピングで使用',
            subtitle: 'ポータブル電源の購入で貯めたポイントを使ってさらにお得に製品を入手できます。',
        },
        {
            step: 'ステップ3：',
            title: 'お好きな特典と引き換え可能',
            subtitle: 'ノベルティグッズ、デジタルギフトなどお好きな特典と交換しましょう。',
        },
    ];

    return (
        <div className={styled.HowUse}>
            {list.map((item, i) => (
                <div key={item.step} className="use_item">
                    <p className="step">{item.step}</p>
                    <p className="title">{item.title}</p>
                    <div className="divider"></div>
                    <p className="subtitle">{item.subtitle}</p>
                    <div className={`img_card img_card_${i}`}></div>
                </div>
            ))}
        </div>
    );
};

export default HowUse;
